import { isProduction } from 'src/libs/wa/utils/env';

export const FEATURE_TAG_ID = 'featureTagId';
export const NEW_ARRIVALS_FEATURE_TAG = 'new';
export const PICKUP_FEATURE_TAG = 'pick_up_items';
export const QUICK_SHIP_FEATURE_TAG = 'quickship';
export const TOP_PAGE_TAG = 'TOP';

export const QUICK_SHIP_FEATURE_TAG_ID = isProduction() ? 70 : 51;
export const LIMITED_SALE_FEATURE_TAG_ID = isProduction() ? 74 : 57;
